import * as THREE from "three";

const toVec3 = (value, fallback = [0, 0, 0]) =>
  Array.isArray(value) && value.length >= 3
    ? [Number(value[0]) || 0, Number(value[1]) || 0, Number(value[2]) || 0]
    : fallback;

export function getSavedLightWorldPose(
  lightDef,
  sceneObjects = {},
  bodies = {},
  sites = {},
  modelGroup = null
) {
  const position = new THREE.Vector3(...toVec3(lightDef?.position, [0, 0, 0]));
  const direction = new THREE.Vector3(...toVec3(lightDef?.direction, [0, 0, -1]));
  if (direction.lengthSq() < 1e-10) direction.set(0, 0, -1);
  direction.normalize();

  if (lightDef?.kind !== "mounted") return { position, direction };

  let mountObject = null;
  let mountPosition = new THREE.Vector3();
  let mountQuaternion = new THREE.Quaternion();
  if (lightDef.mountType === "site" && lightDef.mountSiteUuid) {
    const site = sites?.[lightDef.mountSiteUuid];
    const bodyUuid =
      Object.values(bodies || {}).find(
        (body) => Array.isArray(body?.sites) && body.sites.includes(lightDef.mountSiteUuid)
      )?.uuid || null;
    mountObject = bodyUuid ? sceneObjects?.[bodyUuid] : null;
    if (mountObject && site) {
      mountObject.updateMatrixWorld?.(true);
      mountObject.getWorldPosition(mountPosition);
      mountObject.getWorldQuaternion(mountQuaternion);
      const sitePos = new THREE.Vector3(...toVec3(site.position, [0, 0, 0]));
      const siteQuatRaw =
        Array.isArray(site.orientation) && site.orientation.length === 4
          ? site.orientation
          : [1, 0, 0, 0];
      const siteQuat = new THREE.Quaternion(
        Number(siteQuatRaw[1]) || 0,
        Number(siteQuatRaw[2]) || 0,
        Number(siteQuatRaw[3]) || 0,
        Number(siteQuatRaw[0]) || 1
      ).normalize();
      position.applyQuaternion(siteQuat).add(sitePos);
      direction.applyQuaternion(siteQuat).normalize();
    }
  } else if (lightDef.mountBodyUuid) {
    mountObject = sceneObjects?.[lightDef.mountBodyUuid] || null;
    if (mountObject) {
      mountObject.updateMatrixWorld?.(true);
      mountObject.getWorldPosition(mountPosition);
      mountObject.getWorldQuaternion(mountQuaternion);
    }
  }

  if (!mountObject && modelGroup) {
    mountObject = modelGroup;
    mountObject.updateMatrixWorld?.(true);
    mountObject.getWorldPosition(mountPosition);
    mountObject.getWorldQuaternion(mountQuaternion);
  }

  if (mountObject) {
    position.applyQuaternion(mountQuaternion).add(mountPosition);
    direction.applyQuaternion(mountQuaternion).normalize();
  }

  return { position, direction };
}
